// extracted by mini-css-extract-plugin
export var centerList = "_i0-6";
export var centerLoc = "_i0-a";
export var centerName = "_i0-9";
export var centerOptionBody = "_i0-8";
export var centerRow = "_i0-7";
export var centerStatus = "_i0-b";
export var empty = "_i0-5";
export var externalIcon = "_i0-c";
export var fieldHeader = "_i0-2";
export var fieldHelp = "_i0-4";
export var fieldLabel = "_i0-3";
export var panel = "_i0-0";
export var removeBtn = "_i0-d";
export var section = "_i0-1";